import React from 'react'

const FormLabel = ({ children, ...props }) => (
  <label className="block text-sm mb-2 font-semibold" {...props}>
    { children }
  </label>
)

export { FormLabel }
